import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  UPDATE_LOGIN
} from "../types.js";

const initialState = {
  loginName: "",
  securityToken: "",
  isLoggedIn: false,
  userData: []
};

const loginReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_LOGIN:
      return {
        ...state,
        loginName: payload.loginName ? payload.loginName : "",
        isLoggedIn: payload.securityToken != "" ? true : false,
        securityToken: payload.securityToken ? payload.securityToken : ""
      };
    case LOGIN_FAILURE:
      return { ...state, errorMessageLogin: payload };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginName: payload.loginName ? payload.loginName : "",
        isLoggedIn: payload.securityToken != "" ? true : false,
        securityToken: payload.securityToken ? payload.securityToken : ""
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loginName: "",
        isLoggedIn: false,
        securityToken: ""
      };
    case LOGOUT_FAILURE:
      return { ...state, errorMessageLogout: payload };
    default:
      return state;
  }
};

export default loginReducer;
